import styled from 'styled-components';
import {
  space, color, flexbox, layout, border, position,
} from 'styled-system';


const Flex = styled.div(
  {
    display: 'flex',
  },
  space,
  flexbox,
  color,
  layout,
  border,
  position,
);
export default Flex;
